import { paths } from './paths';

/** Embedded traceability experience (side menu + iframe page). */
export const KNOW_YOUR_CHICKEN_URL = 'https://knowyourfarmer.countrychickenco.in/';
export const KNOW_YOUR_CHICKEN_PATH = paths.knowYourChicken;

/** Footer "Our Products" — category slug URLs. */
export const FOOTER_PRODUCT_LINKS = [
  { label: 'Eggs', path: paths.category('eggs') },
  { label: 'Pickles', path: paths.category('pickles') },
  { label: 'Mutton', path: paths.category('mutton') },
  { label: 'BTB Chicken', path: paths.category('better-than-broiler-chicken') },
  { label: 'Country Chicken (Natukodi)', path: paths.category('village-birds') },
  { label: 'All Products', path: paths.allProducts },
];

/** Know Us — static pages (no About Us). */
export const KNOW_US_LINKS = [
  { label: 'Our Stores', path: paths.stores },
  { label: 'Contact Us', path: paths.contactUs },
  { label: 'Terms And Conditions', path: paths.termsAndConditions },
  { label: 'Privacy Policy', path: paths.privacyPolicy },
  { label: 'Cancellation / Refund Policy', path: paths.refundPolicy },
];

/** Legal / support links for mobile side menu (Know Us without Our Stores). */
export const SIDE_MENU_LEGAL_LINKS = KNOW_US_LINKS.filter(
  (link) => link.path !== paths.stores,
);

export const SOCIAL_LINKS = [
  { label: 'Facebook', url: 'https://www.facebook.com/Countrychickenco/' },
  { label: 'Instagram', url: 'https://www.instagram.com/countrychickenco/' },
  { label: 'WhatsApp', url: 'https://whatsapp.com' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/countrychickenco/' },
];
